module.exports = __webpack_public_path__ + "portal/assets/img/logo.d09addc1.svg";